import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@upstageai/ui";

interface BaseTooltipProps {
  children: React.ReactNode;
  tooltipContent?: React.ReactNode;
  side?: "top" | "bottom" | "left" | "right";
}

export function BaseTooltip({
  children,
  tooltipContent,
  side,
}: BaseTooltipProps) {
  return (
    <TooltipProvider>
      <Tooltip delayDuration={0}>
        <TooltipTrigger asChild>
          {/* 어떤 컴포넌트라도 trigger가 작동되기 위해 div로 감싸기 */}
          <div className="inline-flex">{children}</div>
        </TooltipTrigger>
        {tooltipContent && (
          <TooltipContent side={side} asChild>
            {tooltipContent}
          </TooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>
  );
}
